import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "STIGWB",
  industry: IndustryEnum.Transport,
  name: "STI & GWB",
  pictures: [
    { id: "gwb_niederflurbus_v1.png" },
    { id: "sti_niederflurbus_v1.png" },
    { id: "sti_gelenkbus_v1.png" },
  ],
  previewBaselayers: true,
  slug: "stigwb",
  ...colors,
};
export default config;
